import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import i18n from '../../locales/i18n'

const {
    REACT_APP_SENTRY_DSN: sentryDsn,
    REACT_APP_VERSION: version,
    REACT_APP_PLATFORM: platform,
} = window.APP_CONFIG

/**
 * Get screen dimensions as px string
 *
 * @return {string}
 */
export const getScreenDimensionsPx = () => {
    const documentElement = document?.documentElement
    const body = document?.getElementsByTagName?.('body')?.[0]
    const width = window?.innerWidth || documentElement?.clientWidth || body?.clientWidth || 'undefined'
    const height = window?.innerHeight|| documentElement?.clientHeight|| body?.clientHeight || 'undefined'

    return `${width} x ${height}px`
}

/**
 * Init sentry.io
 *
 * @inheritDoc https://docs.sentry.io/platforms/javascript/
 * @param {Object} history
 */
export const sentryInit = (history) => {
    if (!sentryDsn) {
        return
    }

    Sentry.init({
        dsn: sentryDsn,
        environment: platform,
        debug: platform === 'local',
        release: `v${version}`,
        integrations: [
            new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
            })
        ],
        beforeSend: (body, hint) => {
            const exceptionIsUnhandle = body?.exception?.values?.some?.(exceptionValue => exceptionValue?.mechanism?.type === 'onunhandledrejection')
            if (exceptionIsUnhandle || body?.exception?.mechanism?.type === 'onunhandledrejection') {
                const originalException = hint?.originalException

                if (body?.exception?.values?.length > 0 && originalException?.data) {
                    body.exception.values[0].type = `[unhandled rejection] ${originalException?.statusText}`
                    body.exception.values[0].value = JSON.stringify(originalException?.data || {})
                }

            }

            return body
        },
    })
    Sentry.setTag('version', version)
    Sentry.setTag('user_screen', getScreenDimensionsPx())
}
